import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/match/allPined";

export default class PinService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
